export default "__VITE_ASSET__NlYJHQqx__"